/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './logout.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/services/user.service';
import * as i3 from '@angular/http';
import * as i4 from 'ngx-cookie/src/cookie.service';
import * as i5 from 'angulartics2/dist/core/angulartics2';
import * as i6 from '../../../../app/user/logout/logout.component';
import * as i7 from '@angular/router';
import * as i8 from '@angular/platform-browser';
import * as i9 from '@angular/common';
const styles_LogoutComponent:any[] = [i0.styles];
export const RenderType_LogoutComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LogoutComponent,data:{}});
export function View_LogoutComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(null as any),(null as any));
}
export function View_LogoutComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-logout',
      ([] as any[]),(null as any),(null as any),(null as any),View_LogoutComponent_0,
      RenderType_LogoutComponent)),i1.ɵprd(512,(null as any),i2.UserService,i2.UserService,
      [i3.Http,i4.CookieService,i5.Angulartics2]),i1.ɵdid(2,114688,(null as any),0,
      i6.LogoutComponent,[i2.UserService,i7.Router,i8.DomSanitizer,i9.Location],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const LogoutComponentNgFactory:i1.ComponentFactory<i6.LogoutComponent> = i1.ɵccf('app-logout',
    i6.LogoutComponent,View_LogoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvc3JjL2FwcC91c2VyL2xvZ291dC9sb2dvdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL0FzeWx1bS9pZGVudGl0eS12YWdyYW50L3NyYy9hc3lsdW0taWRlbmV0aXR5L3NyYy9hcHAvdXNlci9sb2dvdXQvbG9nb3V0LmNvbXBvbmVudC50cyIsIm5nOi8vL0M6L1VzZXJzL0FzeWx1bS9pZGVudGl0eS12YWdyYW50L3NyYy9hc3lsdW0taWRlbmV0aXR5L3NyYy9hcHAvdXNlci9sb2dvdXQvbG9nb3V0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvc3JjL2FwcC91c2VyL2xvZ291dC9sb2dvdXQuY29tcG9uZW50LnRzLkxvZ291dENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuPCEtLWluY2x1ZGUgLi4vLi4vaGVhZGVyL2hlYWRlci5wdWctLT5cbjwhLS0jTG9naW5QYWdlXG4jY29udGVudHBhZ2UuaGFzaEFuY29yXG5cdC5jb250YWluZXJcblx0XHQucm93XG5cdFx0XHQudGl0bGVcblx0XHRcdFx0aS5mYS5mYS1hbmdsZS1yaWdodFxuXHRcdFx0XHRoMiBMb2dnaW5nIG91dC4uLlxuLS0+IiwiPGFwcC1sb2dvdXQ+PC9hcHAtbG9nb3V0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsMENBQ3NDO01BQUE7OztvQkNEdEM7TUFBQTtnQ0FBQTtNQUFBLG1EQUFBO3lCQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/app/user/logout/logout.component.ngfactory.ts